module.exports = __webpack_public_path__ + "static/media/image_12.c7935334.png";